export default {
  balances: {
    compile: null,
  },
  isAccountPaneVisible: false,
  grant: null,
  isAuthorising: false,
};



// WEBPACK FOOTER //
// ../../src/user/state.js